// materialThumbnails.js — vieninga vieta, iš kur Suvestinė ir /baldai/:code puslapis
// ima TIKSLIAI tuos pačius pasirinkimo paveiksliukus, kurie rodomi dešiniajame
// konfigūratoriaus meniu ir pasirinkimo dialoguose (ne perkuriame savo ikonų
// rinkinio — importuojame tuos pačius statinius vaizdus / tą pačią image_1
// laukų skiriamosios gebos logiką).

import { API_HOST } from '../../config.js';
import { allBasisOptions } from '../components/tabs/Basis.jsx';
import { edgesOptions } from '../components/tabs/Edges.jsx';
import { HANDLE_IMAGES, getHandleTypeLabel } from '../components/tabs/PlatesFillingsAndHandles.jsx';
import { doorOptions } from '../dialogs/OuterSelectingDialog.jsx';
import { ITEM_IMAGES, ITEM_LABELS } from '../dialogs/InnerSelectingDialog.jsx';

// LMDP/MDF korpuso arba durų plokštė — DB katalogo objektas su image_1/image lauku.
export const resolvePlateImage = (plate) => {
    if (!plate) return null;
    const imageName = plate.image_1 || plate.image;
    if (!imageName) return null;
    if (imageName.startsWith('http')) return imageName;
    const folder = plate.panelType === 1 ? 'mdf' : 'lmdp';
    return `${API_HOST}/${folder}/${imageName}`;
};

// Konkreti rankena / veidrodis / užpildas — DB katalogo objektas, saugomas uploads/.
export const resolveUploadImage = (item) => {
    if (!item) return null;
    const imageName = item.image_1 || item.image_2 || item.image;
    if (!imageName) return null;
    if (imageName.startsWith('http')) return imageName;
    return `${API_HOST}/uploads/${imageName}`;
};

export const getBasisImage = (basisType) => allBasisOptions[Number(basisType)]?.image || null;
export const getBasisLabel = (basisType) => allBasisOptions[Number(basisType)]?.title || '';

export const getEdgesImage = (edges) => edgesOptions[Number(edges)]?.image || null;
export const getEdgesLabel = (edges) => edgesOptions[Number(edges)]?.title || '';

export const getHandleTypeImage = (handleType) => HANDLE_IMAGES[Number(handleType)] || null;
export { getHandleTypeLabel };

export const getDoorTypeImage = (doorType) => doorOptions[Number(doorType)]?.image || null;
export const getDoorTypeLabel = (doorType) => doorOptions[Number(doorType)]?.label || '';

export const getInteriorItemImage = (type) => ITEM_IMAGES[Number(type)] || null;
export const getInteriorItemLabel = (type) => ITEM_LABELS[Number(type)] || `Elementas ${type}`;
